'use client';
import { useEffect } from "react";
import '../../app/einbuergerungstest/mocktest/bavaria/MockTest.css';
import '../../app/blogs/[category]/Blogs.css';

const Pagination = ({ currentPage, totalPages, onPageChange, scrollToId }) => {
  useEffect(() => {
    if (currentPage) {
      const element = document.getElementById(scrollToId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
        return;
      }
      window.scrollTo({
        top: 150,
        behavior: "smooth"
      });
    }
  }, [currentPage]);

  const generatePages = () => {
    const pages = [];

    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      pages.push(1);

      if (currentPage > 3) pages.push("...");

      const start = Math.max(2, currentPage - 1);
      const end = Math.min(totalPages - 1, currentPage + 1);
      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      if (currentPage < totalPages - 2) pages.push("...");

      pages.push(totalPages);
    }

    return pages;
  };

  return (
    <div className="pagination" id="blog-pagination">
      <button className="pagination-btn" id="pagination-btn-prev" onClick={() => onPageChange(currentPage - 1)} disabled={currentPage === 1}>
        PREV
      </button>

      {generatePages().map((page, index) =>
        page === "..." ? (
          <span id="pagination-btn-no" key={index}>...</span>
        ) : (
          <button
            key={index}
            onClick={() => onPageChange(page)}
            className={page === currentPage ? "active" : ""}
            id="pagination-btn-no"
          >
            {page}
          </button>
        )
      )}

      <button className="pagination-btn" id="pagination-btn-next" onClick={() => onPageChange(currentPage + 1)} disabled={currentPage === totalPages}>
        NEXT
      </button>
    </div>
  );
};

export default Pagination;
